import { createSlice } from '@reduxjs/toolkit';

import { PlayerStatsState } from './types';

/**
 * @type {PlayerStatsState}
 */
const initialState = {
    nav: {
        stats: 'Basic',
        teams: 'Both'
    },
    sort: {
        columnId: 'player',
        sortDirection: 'ascending',
        force: false
    },
    dataType: {
        type: 'totals'
    },
    customFields: [],
    temporaryFields: [],
    modal: {
        isOpen: false
    }
};

const mcPlayerStatsSlice = createSlice({
    name: 'mcPlayerStats',
    initialState,
    reducers: {
        setNavItem: (state, action) => {
            const { navItem, value } = action.payload;

            if (state.nav[navItem] === null) {
                state.nav[navItem] = value;
                return;
            }

            if (typeof state.nav[navItem] === 'object') {
                state.nav[navItem] = {
                    ...state.nav[navItem],
                    ...value
                };
                return;
            }

            state.nav[navItem] = value;
        },
        setSort: (state, action) => {
            state.sort = {
                ...state.sort,
                ...action.payload
            };
        },
        setDataType: (state, action) => {
            state.dataType = {
                ...state.dataType,
                ...action.payload
            };
        },
        setCustomFields: (state, action) => {
            state.customFields = action.payload.data ?? [];
        },
        setModal: (state, action) => {
            state.modal = {
                isOpen: action.payload.isOpen ?? false
            };
        },
        setTemporaryFields: (state, action) => {
            state.temporaryFields = action.payload.data ?? [];
        }
    }
});

if (window.PULSE.app.redux) {
    PULSE.app.redux.reducers.mcPlayerStats = {
        root: mcPlayerStatsSlice.reducer
    };
    PULSE.app.redux.actions = {
        ...PULSE.app.redux.actions,
        mcPlayerStats: mcPlayerStatsSlice.actions
    };
} else {
    PULSE.app.redux = {
        actions: {
            mcPlayerStats: mcPlayerStatsSlice.actions
        },
        reducers: {
            root: {
                mcPlayerStats: mcPlayerStatsSlice.reducer
            }
        }
    };
}

export const {
    setNavItem,
    setDataType,
    setSort,
    setCustomFields,
    setModal,
    setTemporaryFields
} = mcPlayerStatsSlice.actions;
